export enum MentorEducationChoice {    
    Undecided = 0,
    PrefersVoucher = 1,
    PrefersDirectDonation = 2
}